import React from "react";
import charts from "../images/screenshots/charts.png";
import stocks_added from "../images/screenshots/stocks_added.png";
import { Link } from "react-router-dom";
import ReactWOW from "react-wow";

class RemoteManagement extends React.Component {
  render() {
    return (
      <div className="has-background-white">
        <div>
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
        <div className="container">
          <div>
            <div className="has-text-centered is-size-5 has-text-grey">
              AS A BUSINESS OWNER
            </div>
          </div>
          <div>
            <br />
            <br />
            <br />
          </div>
          <div className="columns">
            <div className="column is-6">
              <ReactWOW animation="slideInLeft">
                <div>
                  <img src={charts} alt="" />
                </div>
              </ReactWOW>
            </div>

            <div className="column d-flex justify-content-center align-items-center">
              <div>
                <div className="title has-text-right">
                  WATCH YOUR BUSINESS FROM ANYWHERE.
                </div>
                <div className="has-text-right mt-2 is-size-5">
                  <i>Right from your Mobile Phone.</i>
                </div>

                <div className="has-text-right">
                  <br />
                  <ReactWOW animation="slideInUp">
                    <div className="mt-2">
                      <Link to="/signup/">
                        <button className="button is-link">
                          <span className="zmdi zmdi-eye mr-2"></span>
                          <span>Start Watching</span>
                        </button>
                      </Link>
                    </div>
                  </ReactWOW>
                </div>
              </div>
            </div>
          </div>

          <div>
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>
          <div className="columns">
            <div className="column d-flex justify-content-center align-items-center">
              <div>
                <div className="is-size-3">
                  From Anywhere, understand what comes in and what goes out.
                </div>
                <div className="mt-2 is-size-5">
                  <i> With insights on what to improve.</i>
                </div>

                <div className="t">
                  <br />
                  <ReactWOW animation="slideInUp">
                    <div className="mt-2">
                      <Link to="/signup/">
                        <button className="button is-link">
                          <span className="zmdi zmdi-plus mr-2"></span>
                          <span>Add your Business</span>
                        </button>
                      </Link>
                    </div>
                  </ReactWOW>
                </div>
              </div>
            </div>
            <div className="column is-7">
              <ReactWOW animation="slideInRight">
                <div>
                  <img src={stocks_added} alt="" />
                </div>
              </ReactWOW>
            </div>
          </div>
        </div>

        <div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
    );
  }
}

export default RemoteManagement;
